import { mockDoctors } from "../data/mockData";
import { ROSTER } from "../data/sporeGames";

const KEY = "spore_progress";

const isPlainObject = (v) => v !== null && typeof v === "object" && !Array.isArray(v);

const toSeconds = (v) => {
  if (typeof v === "number") return Number.isFinite(v) && v >= 0 ? v : null;
  if (typeof v === "string" && v.trim() !== "") return toSeconds(Number(v));
  return null;
};

export const getProgress = () => {
  let raw;
  try {
    raw = JSON.parse(localStorage.getItem(KEY));
  } catch {
    return {};
  }
  if (!isPlainObject(raw)) return {};
  const clean = {};
  mockDoctors.forEach(({ id }) => {
    const seconds = isPlainObject(raw[id]) ? toSeconds(raw[id].seconds) : null;
    if (seconds !== null) clean[id] = { ...raw[id], seconds };
  });
  return clean;
};

export const markRevealed = (id, seconds) => {
  const p = getProgress();
  const best = p[id] ? Math.min(p[id].seconds, seconds) : seconds;
  p[id] = { seconds: best, last: seconds, at: Date.now() };
  localStorage.setItem(KEY, JSON.stringify(p));
  return p;
};

export const resetProgress = () => localStorage.removeItem(KEY);

export const nextSealedId = (currentId, progress) => {
  const ids = ROSTER.map((d) => d.id);
  const start = ids.indexOf(currentId);
  for (let i = 1; i <= ids.length; i += 1) {
    const id = ids[(start + i + ids.length) % ids.length];
    if (!progress[id]) return id;
  }
  return null;
};
